
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viden",
      function () {
        return require("private-next-pages/viden/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viden"])
      });
    }
  